import type { DialogContentProps } from '@radix-ui/react-dialog';
import { Content } from '@radix-ui/react-dialog';
import { forwardRef } from 'react';

export const DrawerContent = forwardRef<
  HTMLDivElement,
  Omit<DialogContentProps, 'asChild'>
>(({ children, ...delegatedProps }, forwardedRef) => {
  return (
    <Content
      asChild
      ref={forwardedRef}
      className="fixed inset-y-0 right-0 flex w-[400px] flex-col bg-level-01 text-default"
      role="complementary"
      // @see https://www.radix-ui.com/primitives/docs/components/dialog#description
      aria-describedby={undefined}
      {...delegatedProps}
    >
      <aside>{children}</aside>
    </Content>
  );
});
DrawerContent.displayName = 'DrawerContent';
